import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

class Resume extends React.Component {
  constructor(props) {
    super(props);
    const work = require('./work.json');

    this.state = {
      resume: work.experience,
        technologies: work.technologies
    };
  }

  render() {
    return (
      <div>
        <h2 style={{ color: '#166088'}}>Work Experience</h2>
        <hr style={{ width: '75%', padding: '1em'}}/>
        {this.state.resume && this.state.resume.map((item, i) => {
        return(
          <Container key={'section_' + i}>
            <Row>
              <Col as={'h3'} style={{ color: '#FE5F55'}} sm={5}>{item.company}<br /><span style={{ fontSize: '12px', color: '#577399', fontStyle: 'italic'}}>{item.companyInfo}</span></Col>
              <Col sm={4}><strong>{item.title}</strong></Col>
              <Col className={'text-secondary'} sm={3}>{item.dates}</Col>
            </Row>
            <Row>
              <ul>
              {item.responsibilities.map((responsibility, ia) => {
                return (<li key={'item' + i + '-' + ia}>{responsibility}</li>);
                })
              }
              </ul>
            </Row>
            <Row><hr /></Row>
          </Container>
          );
        })
        }
        <h2 style={{ color: '#166088'}}>Certifications</h2>
        <hr style={{ width: '75%', padding: '1em'}}/>
          <Container>
            <ul>
              <li>ScrumMaster 2021</li>
            </ul>
          </Container>
        <h2 style={{ color: '#166088'}}>Technologies Used</h2>
        <hr style={{ width: '75%', padding: '1em'}}/>
          <Container>
            <ul>
          {this.state.technologies && this.state.technologies.map((item, i) => {
              return(
                  <li key={'tech_' + i}>{item}</li>
              );
          })
          }
            </ul>
              </Container>
      </div>

        );
  }
}

export default Resume;